import React from "react";

const TextField = ({
  name,
  id,
  type,
  placeholder,
  className,
  onChange,
  onBlur,
  validation,
  validationMsg,
  onkeypress,
  value,
  maxlength,
  style,
  dataQuestId,
  keypress
}) => {
  return (
    <>
      <input
        name={name}
        id={id}
        data-quest-id={dataQuestId}
        placeholder={placeholder}
        className={className}
        type={type}
        onChange={onChange}
        onBlur={onBlur}
        onKeyPress={onkeypress}
        ref={validation}
        defaultValue={value}
        maxLength={maxlength}
        style={style}
        onKeyPress={keypress}
      />
      {validationMsg && (
        <>
          <span className="error_msg">{validationMsg}</span>
        </>
      )}
    </>
  );
};
export default TextField;
